import Vue from 'vue'
import VueRouter from 'vue-router'
// Configuracion
import EmpleadosView from './views/configuraciones/Empleados.view.vue'
import UsuariosView from './views/configuraciones/accesos/usuarios.view.vue'
import RolesView from './views/configuraciones/accesos/roles.view.vue'
import PermisosView from './views/configuraciones/accesos/permisos.view.vue'
import FormCaracteristicaView from './views/configuraciones/FormCaracteristicas.view.vue'
// Catalogos
import CaracteristicasView from './views/catalogo/Caracteristicas.view.vue'
import TiposDatosView from './views/catalogo/TipoDato.view.vue'
import DepartamentoView from './views/catalogo/Departamentos.view.vue'
import FamiliasView from './views/catalogo/Familias.view.vue'
import MarcasView from './views/catalogo/Marcas.view.vue'
import ProcedenciasView from './views/catalogo/Procedencias.view.vue'
import ProveedoresView from './views/catalogo/Proveedores.view.vue'
import TiposContratacionesView from './views/catalogo/TiposContrataciones.view.vue'
import PartidasView from './views/catalogo/Partidas.view.vue'
// Inventarios
import EquiposView from './views/inventarios/equipos.view.vue'
import InsumosView from './views/inventarios/insumos.view.vue'
import RefacionesView from './views/inventarios/refaciones.view.vue'
import almacenView from './views/inventarios/almacen.view.vue'

// Configuraciones
import PanelEmpresaView from './views/configuraciones/procesos/PanelEmpresa.view.vue'

Vue.use(VueRouter)

export default new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'inicio',
      component: () => import(/* webpackChunkname: "login" */ './views/login.view.vue'),
      meta: {
        breadcrumb: [],
        name: ''
      }
    },
    {
      path: '/home',
      name: 'home',
      // beforeEnter
      meta: {
        allowAnonymous: true,
        breadcrumb: [{ name: 'Inicio' }],
        name: 'Sistema de Integral de Gestión de Servicios'
      },
      component: () => import(/* webpackChunkname: "Home" */ './views/home.view.vue')
    },
    // ========== Configuraciones ========== \\
    {
      path: '/Configuraciones/Empleados',
      name: 'ConfigEmpleadosView',
      meta: {
        allowAnonymous: true,
        name: 'Empleados',
        breadcrumb: [{ name: 'Configuraciones' }, { name: 'Empleados' }]
      },
      component: EmpleadosView
    },
    {
      path: '/Configuraciones/accesos/Usuarios',
      name: 'ConfigAuthUsersView',
      meta: {
        allowAnonymous: true,
        name: 'Usuarios',
        breadcrumb: [{ name: 'Configuraciones' }, { name: 'Acceso' }, { name: 'Usuarios' }]
      },
      component: UsuariosView
    },
    {
      path: '/Configuraciones/Acceso/Roles',
      name: 'ConfigAuthRolsView',
      meta: {
        allowAnonymous: true,
        name: 'Roles',
        breadcrumb: [{ name: 'Configuraciones' }, { name: 'Acceso' }, { name: 'Roles' }]
      },
      component: RolesView
    },
    {
      path: '/Configuraciones/Acceso/Permisos',
      name: 'ConfigAuthPermissView',
      meta: {
        allowAnonymous: true,
        name: 'Permisos',
        breadcrumb: [{ name: 'Configuraciones' }, { name: 'Acceso' }, { name: 'Permisos' }]
      },
      component: PermisosView
    },
    {
      path: '/Configuraciones/FormFamiliaCaracterristicas',
      name: 'FormCaracteristicaView',
      meta: {
        allowAnonymous: true,
        name: 'Formulario de Familia-Caracteristicas',
        breadcrumb: [{ name: 'Configuraciones' }, { name: 'Formulario de Familia y Caracteristicas' }]
      },
      component: FormCaracteristicaView
    },
    // ========== Catalogos ========== \\
    {
      path: '/Catalogos/Caracteristicas',
      name: 'CaracteristicasView',
      meta: {
        allowAnonymous: true,
        name: 'Características',
        breadcrumb: [{ name: 'Catálogos' }, { name: 'Características' }]
      },
      component: CaracteristicasView
    },
    {
      path: '/Catalogos/TiposDatos',
      name: 'TiposDatosView',
      meta: {
        allowAnonymous: true,
        name: 'Tipos de Datos',
        breadcrumb: [{ name: 'Catálogos' }, { name: 'Tipos de Datos' }]
      },
      component: TiposDatosView
    },
    {
      path: '/Catalogos/Departamentos',
      name: 'DepartamentoView',
      meta: {
        allowAnonymous: true,
        name: 'Departamentos',
        breadcrumb: [
          { name: 'Empresa' },
          { name: 'Departamentos' }
        ]
      },
      component: DepartamentoView
    },
    {
      path: '/Catalogos/Familias',
      name: 'FamiliasView',
      meta: {
        allowAnonymous: true,
        name: 'Familias',
        breadcrumb: [{ name: 'Catálogos' }, { name: 'Familia' }]
      },
      component: FamiliasView
    },
    {
      path: '/Catalogo/Marcas',
      name: 'MarcasView',
      meta: {
        allowAnonymous: true,
        name: 'Marcas',
        breadcrumb: [{ name: 'Catalogo' }, { name: 'Marca' }]
      },
      component: MarcasView
    },
    {
      path: '/Catalogo/Procedencias',
      name: 'ProcedenciasView',
      meta: {
        allowAnonymous: true,
        name: 'Procedencias',
        breadcrumb: [{ name: 'Catalogo' }, { name: 'Procedencias' }]
      },
      component: ProcedenciasView
    },
    {
      path: '/Catalogos/Proveedores',
      name: 'ProveedoresView',
      meta: {
        allowAnonymous: true,
        name: 'Proveedores',
        breadcrumb: [{ name: 'Catálogos' }, { name: 'Proveedores' }]
      },
      component: ProveedoresView
    },
    {
      path: '/Catalogos/TiposContrataciones',
      name: 'TiposContratacionesView',
      meta: {
        allowAnonymous: true,
        name: 'Tipos de Contrataciones',
        breadcrumb: [{ name: 'Catálogos' }, { name: 'Tipos de Contrataciones' }]
      },
      component: TiposContratacionesView
    },
    {
      path: '/Catalogos/Partidas',
      name: 'PartidasView',
      meta: {
        allowAnonymous: true,
        name: 'Partidas',
        breadcrumb: [{ name: 'Catálogos' }, { name: 'Partidas' }]
      },
      component: PartidasView
    },
    // ============================================================== \\
    // ============================================================== \\
    // ============================================================== \\
    {
      path: '/Formulario',
      name: 'video',
      meta: {
        allowAnonymous: true,
        breadcrumb: [
          { name: 'Form' }
        ]
      },
      component: () => import('./views/ejemplos/form.view.vue')
    },
    {
      path: '/Table',
      name: 'table',
      meta: {
        allowAnonymous: true,
        breadcrumb: [
          { name: 'Table' }
        ]
      },
      component: () => import('./views/ejemplos/table.view.vue')
    },
    {
      path: '/Importador',
      name: 'importador',
      meta: {
        allowAnonymous: true,
        breadcrumb: [
          { name: 'Importador' }
        ]
      },
      component: () => import('./views/ejemplos/importador.view.vue')
    },
    {
      path: '/Menu',
      name: 'menu',
      meta: {
        allowAnonymous: true,
        breadcrumb: [
          { name: 'Menu Dinamico' }
        ]
      },
      component: () => import('./views/ejemplos/MenuDinamic.view.vue')
    },

    // Mesa de ayuda \\
    {
      path: '/MesaAyuda/Solicitudes',
      name: 'MeAyuSolicitudes',
      meta: {
        allowAnonymous: true,
        breadcrumb: [
          { name: 'Mesa Ayuda' },
          { name: 'Solicitudes' }
        ],
        name: 'Solicitudes'
      },
      component: () => import('./views/mesaAyuda/solicitudes.view.vue')
    },

    {
      path: '/MesaAyuda/Calendario',
      name: 'MeAyuCalendar',
      meta: {
        allowAnonymous: true,
        breadcrumb: [
          { name: 'Mesa Ayuda' },
          { name: 'Calendario' }
        ],
        name: 'Calendario de Actividades'
      },
      component: () => import('./views/mesaAyuda/calendarSolicitudes.view.vue')
    },
    // Catalogos \\
    {
      path: '/Catalogo/Roles/Permisos/:id',
      name: 'ViewPermissionsRoleAssign',
      meta: {
        allowAnonymous: true,
        name: 'Asignar Permisos a Rol',
        breadcrumb: [
          { name: 'Catalogo' },
          { name: 'Roles' },
          { name: 'Asignacion de Permisos' }
        ]
      },
      component: () => import('./views/company/rolePermissionsAssign.view.vue')
    },
    // Inventarios \\
    {
      path: '/Inventarios/Equipos',
      name: 'InvEquipos',
      meta: {
        allowAnonymous: true,
        name: 'Equipos de Computos',
        breadcrumb: [{ name: 'Inventarios' }, { name: 'Equipos' }]
      },
      component: EquiposView
    },
    {
      path: '/Inventarios/Insumos',
      name: 'InvInsumos',
      meta: {
        allowAnonymous: true,
        name: 'Consumibles de mantenimientos e Intalaciones',
        breadcrumb: [{ name: 'Inventarios' }, { name: 'Insumos' }]
      },
      component: InsumosView
    },
    {
      path: '/Inventarios/Refacciones',
      name: 'InvRefaciones',
      meta: {
        allowAnonymous: true,
        name: 'Piezas de Equipos de Computos Rescatados ',
        breadcrumb: [{ name: 'Inventarios' }, { name: 'Refacciones' }]
      },
      component: RefacionesView
    },
    {
      path: '/Inventario/Insumos/Almacen',
      name: 'InvInsumoAlmacen',
      meta: {
        allowAnonymous: true,
        breadcrumb: [{ name: 'Inventarios' }, { name: 'Almacen' }],
        name: 'Almacen Insumos'
      },
      component: almacenView
    },

    // {
    //   path: '/Inventarios/Proveedores',
    //   name: 'InvProveedores',
    //   meta: {
    //     allowAnonymous: true,
    //     breadcrumb: [
    //       { name: 'Inventarios' },
    //       { name: 'Proveedores' }
    //     ]
    //   },
    //   component: () => import('./views/inventarios/proveedores.view.vue')
    // },

    {
      path: '/Inventarios/Importador',
      name: 'InvImportador',
      meta: {
        allowAnonymous: true,
        name: 'Importador',
        breadcrumb: [
          { name: 'Inventarios' },
          { name: 'Importador' }
        ]
      },
      component: () => import('./views/inventarios/importadorMain.view.vue')
    },
    {
      path: '/Configuraciones/Test-Email',
      name: 'InvTestEmial',
      meta: {
        allowAnonymous: true,
        name: 'Test Email',
        breadcrumb: [
          { name: 'Configuraciones' },
          { name: 'Test Email' }
        ]
      },
      component: () => import('./views/inventarios/testemail.view.vue')
    },
    // Configuraciones \\
    {
      path: '/Configuraciones/TiposProcesos',
      name: 'ViewProcesos',
      meta: {
        allowAnonymous: true,
        name: 'Tipos de Procesos',
        breadcrumb: [
          { name: 'Configuraciones' },
          { name: 'Tipos de Procesos' }
        ]
      },
      component: () => import('./views/company/configuraciones/procesos.view.vue')
    },
    {
      path: '/Configuraciones/RutinasProcesos/PanelEmpresa',
      name: 'ConfigRutProcPanelEmpresa',
      meta: {
        allowAnonymous: true,
        name: 'Panel de Datos de Empresa',
        breadcrumb: [{ name: 'Configuraciones' }, { name: 'Rutinas y Procesos' }, { name: 'Panel de Empresa' }]
      },
      component: PanelEmpresaView
    }
    // Fin Configuraciones Fin \\
  ]
})
